<template>
  <div class="hdchthtlist">
    <div class="tagtitle flex_start">
      <div
        class="tagitem"
        v-for="(item, index) in taglist"
        :key="index"
        :class="{ itemac: index == tagact }"
        @click="tagcli(item)"
      >
        {{ item.tagtitle }}
      </div>
    </div>
    <div class="htlist between wrap">
      <htcarditem
        class="htitem"
        v-for="(item, index) in htlist"
        :key="index"
        :hditem="item"
      />
    </div>
    <div class="pagination mt50" v-if="htlist.length">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-count="pageCount"
        :current-page="currentPage"
        :pager-count="7"
        @current-change="turnpage"
        @prev-click="turnpage(--currentPage)"
        @next-click="turnpage(++currentPage)"
      >
      </el-pagination>
      <div class="textnum">[共{{ pageCount }}页]</div>
    </div>
  </div>
</template>

<script>
import htcarditem from "views/contractmodel/components/htcarditem.vue";
export default {
  components: {
    htcarditem,
  },
  data: () => ({
    tagact: 0,
    taglist: [
      { tagtitle: "热门合同", id: 0 },
      { tagtitle: "最新合同", id: 1 },
    ],
    currentPage: 1, //当前
    pageCount: 17, //总页数
    total: 17, //总条目,
    htlist: [],
  }),
  computed: {
    hdcolId() {
      return this.$store.state.jpcol.hdcolId;
    },
  },
  beforeMount() {
    this.gethdlist();
  },
  methods: {
    tagcli(item) {
      if (this.tagact == item.id) return;
      this.tagact = item.id;
      this.gethdlist();
    },
    turnpage(e) {
      this.currentPage = e;
      this.gethdlist();
    },
    gethdlist() {
      let data = {
        order: this.tagact == 0 ? "hot" : "new",
        limit: 16,
        page: this.currentPage,
        cat_id: this.hdcolId,
      };
      this.$http.jpcol
        .getcontractlist(data)
        .then((res) => {
          this.pageCount = res.data.last_page;
          this.total = res.data.count;
          this.htlist = res.data.data;
        })
        .catch((err) => {});
    },
  },
  watch: {
    hdcolId() {
      this.currentPage = 1;
      this.gethdlist();
    },
  },
};
</script>

<style lang="scss" scoped>
.hdchthtlist {
  width: 1200px;
  margin: 0 auto;
  padding: 0 0 50px;
  .tagtitle {
    margin-top: 30px;
    .tagitem {
      cursor: pointer;
      width: 130px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      margin-right: 16px;
      background: #fff;
      color: #323232;
      &.itemac {
        color: #ffffff;
        background: #0465ea;
      }
    }
  }
  .htlist {
    .htitem {
      width: 282px;
      height: 417px;
      background: #ffffff;
      padding: 22px;
      margin-top: 30px;
      box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
      .cove {
        img {
          width: 240px;
          height: 300px;
        }
      }
      .text {
        margin-top: 18px;
        font-size: 16px;
        color: #323232;
        .num {
          margin-top: 16px;
          .pri {
            font-size: 14px;
            color: #da0000;
          }
          .xd {
            font-size: 14px;
            color: #969696;
          }
        }
      }
      .download {
        display: none;
        cursor: pointer;
        width: 116px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        margin: 24px auto;
        background: #f25618;
        border-radius: 18px;
        font-size: 18px;
        color: #ffffff;
      }

      &:hover {
        .text {
          display: none;
        }
        .download {
          display: block;
        }
      }
    }
  }
  .pagination {
    text-align: center;
    ::v-deep .el-pagination.is-background .btn-next,
    ::v-deep .el-pagination.is-background .btn-prev,
    ::v-deep .el-pagination button,
    ::v-deep .el-pagination span:not([class*="suffix"]),
    ::v-deep .el-pagination.is-background .el-pager li {
      min-width: 36px;
      height: 36px;
      line-height: 36px;
    }
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active,
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #ffffff !important;
      background: #0057ff !important;
    }
    .textnum {
      color: #333;
      margin-top: 15px;
    }
  }
}
</style>